import { ProductStatus } from "@/services/api/setting/product";

const ProductStatusNameMap = {
    [ProductStatus.DELETED]: "已删除",

    [ProductStatus.IN_STOCK]: "仓库中",

    [ProductStatus.ON_SALE]: "销售中",
};

export default ProductStatusNameMap;
